module.exports = __webpack_public_path__ + "ba1c4d611835203564f5c43fe27d6cfb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Accordion/components/Tab/images/ic_collapse.svg
// module id = 1349
// module chunks = 1